import _extends from "../../../@babel/runtime/helpers/esm/extends.es.js";
import * as React from "react";
import { j as jsxRuntimeExports } from "../../../react/jsx-runtime.es.js";
import SvgIcon from "../SvgIcon/SvgIcon.es.js";
function createSvgIcon(path, displayName) {
  function Component(props, ref) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon, _extends({
      "data-testid": `${displayName}Icon`,
      ref
    }, props, {
      children: path
    }));
  }
  if (process.env.NODE_ENV !== "production") {
    Component.displayName = `${displayName}Icon`;
  }
  Component.muiName = SvgIcon.muiName;
  return /* @__PURE__ */ React.memo(/* @__PURE__ */ React.forwardRef(Component));
}
export {
  createSvgIcon as default
};
//# sourceMappingURL=createSvgIcon.es.js.map
